import React, { useState, useEffect } from 'react';
import './ResumenHoteles.css'; 

// === API CONFIGURATION (PRODUCTION READY) ===
const getApiUrl = () => {
  // Check for environment variable
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  // Default to relative path for production (same domain)
  return ''; 
};

const API_URL = getApiUrl();

const renderNumber = (value, decimals = 2, isCurrency = false, isPercentage = false) => {
    const num = parseFloat(value);
    if (value === null || isNaN(num)) return 'N/A';
    if (isCurrency) {
        return num.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    } else if (isPercentage) {
        return num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + '%';
    }
    return num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

const ResumenHoteles = () => {
    const [isOpen, setIsOpen] = useState(false); 
    const [data, setData] = useState([]);
    const [totals, setTotals] = useState(null);
    const [loading, setLoading] = useState(true);

    const toggleOpen = () => setIsOpen(!isOpen);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                
                // --- FIX: Use API_URL constant instead of hardcoded localhost ---
                // If API_URL is empty (production), it requests relative path "/api.php?..."
                const response = await fetch(`${API_URL}/api.php?path=reports/hotel_summary`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (response.ok) {
                    const result = await response.json();
                    if (result.success) {
                        setData(result.data.hotels || []);
                        setTotals(result.data.totals || null);
                    }
                }
            } catch (error) {
                console.error("Error loading hotel summary:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="resumen-hoteles-container">
            <div className="resumen-header" onClick={toggleOpen}>
                <h3>Resumen de Hoteles Propios</h3>
                <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </div>

            {isOpen && (
                <div className="resumen-content">
                    {loading ? (
                        <p className="loading-text">Cargando resumen...</p>
                    ) : (
                        <table className="resumen-table">
                            <thead>
                                <tr>
                                    <th>Hotel</th>
                                    <th className="text-right">Ventas</th>
                                    <th className="text-right">Occ %</th>
                                    <th className="text-right">ADR</th>
                                    <th className="text-right">Ingreso Total</th>
                                    <th className="text-right">Ingreso Acumulado</th>
                                    <th className="text-right">RevPAR</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.hotel_name}</td>
                                        <td className="text-right">{renderNumber(row.rooms_sold, 0)}</td>
                                        <td className="text-right">{renderNumber(row.occupancy_percent, 2, false, true)}</td>
                                        <td className="text-right">{renderNumber(row.adr, 2, true)}</td>
                                        <td className="text-right">{renderNumber(row.total_revenue, 2, true)}</td>
                                        <td className="text-right">{renderNumber(row.accumulated_revenue, 2, true)}</td>
                                        <td className="text-right">{renderNumber(row.revpar, 2, true)}</td>
                                    </tr>
                                ))}
                                {totals && (
                                    <tr className="total-row">
                                        <td>Total / Promedio</td>
                                        <td className="text-right">{renderNumber(totals.rooms_sold, 0)}</td>
                                        <td className="text-right">{renderNumber(totals.occupancy_percent, 2, false, true)}</td>
                                        <td className="text-right">{renderNumber(totals.adr, 2, true)}</td>
                                        <td className="text-right">{renderNumber(totals.total_revenue, 2, true)}</td>
                                        <td className="text-right">{renderNumber(totals.accumulated_revenue, 2, true)}</td>
                                        <td className="text-right">{renderNumber(totals.revpar, 2, true)}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
    );
};

// --- THIS LINE IS CRITICAL ---
export default ResumenHoteles;